module.exports = __webpack_public_path__ + "assets/9c32a0302249dc271d1ce40d83aca1d4.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/engine/public-src/spingames/panel/sounds/buttons/denoms/denom_100.mp3
 ** module id = 49
 ** module chunks = 0
 **/